import React from 'react';
import { Helmet } from 'react-helmet';
import contentData from '../../data/contentData.json';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  noindex = false 
}) => {
  const companyName = contentData.company.name;
  const defaultDescription = `${companyName} - ${contentData.company.tagline}. ${contentData.company.mission}`;
  
  const seoTitle = title ? `${title} | ${companyName}` : `${companyName} | ${contentData.company.tagline}`;
  const seoDescription = description || defaultDescription;
  const seoImage = image || '/assets/dhyon-og-image.jpg';
  const seoUrl = url || window.location.href;
  
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": companyName,
    "description": contentData.company.mission,
    "url": "https://dhyon.com",
    "logo": "/assets/dhyon-logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": contentData.company.contact.phone,
      "contactType": "customer service",
      "email": contentData.company.contact.email
    },
    "address": contentData.company.locations.map(location => ({
      "@type": "PostalAddress",
      "addressLocality": location.city,
      "streetAddress": location.address
    })),
    "sameAs": [
      "https://linkedin.com/company/dhyon-technologies",
      "https://twitter.com/dhyon_tech"
    ]
  };

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={companyName} />
      
      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content={noindex ? 'noindex,nofollow' : 'index,follow'} />
      <meta name="author" content={companyName} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={seoUrl} />
      
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      
      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=GA_TRACKING_ID"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'GA_TRACKING_ID');
        `}
      </script>
    </Helmet>
  );
};

export default SEO; 